import { Palette, ThemeOptions } from '@mui/material/styles';
import type { } from '@mui/lab/themeAugmentation';

import { Paths } from './utils';


type GeneralColors =
    | 'primary10'
    | 'primary20'
    | 'primary30'
    | 'primary50'
    | 'primary60'
    | 'primary80'
    | 'secondary10'
    | 'secondary20'
    | 'secondary30'
    | 'secondary50'
    | 'secondary60'
    | 'secondary80'

type GrayscaleColors =
    | 'bWtoDark'
    | 'bw10'
    | 'bw60'
    | 'bw80'
    | 'bw95'
    | 'shade0'
    | 'shade10'
    | 'shade100'
    | 'shade20'
    | 'shade40'
    | 'shade5'
    | 'shade60'
    | 'shade80'
    | 'shade85'
    | 'shade90'
    | 'shade95'
    | 'shade98'

type InfoColors =
    | 'green10'
    | 'green20'
    | 'green30'
    | 'green50'
    | 'green60'
    | 'green80'
    | 'orange10'
    | 'orange20'
    | 'orange30'
    | 'orange50'
    | 'orange60'
    | 'orange80'
    | 'red10'
    | 'red20'
    | 'red30'
    | 'red50'
    | 'red60'
    | 'red80'
    | 'yellow10'
    | 'yellow20'
    | 'yellow30'
    | 'yellow50'
    | 'yellow60'

declare module '@mui/material/styles' {
    interface Palette {
        general?: Record<GeneralColors, string>;
        grayscale?: Record<GrayscaleColors, string>;
        infoCustom?: Record<InfoColors, string>;
    }
    interface PaletteOptions {
        general?: Record<GeneralColors, string>;
        grayscale?: Record<GrayscaleColors, string>;
        infoCustom?: Record<InfoColors, string>;
    }
}

export type PaletteColor = Paths<Pick<Palette, 'general' | 'grayscale' | 'infoCustom'>>;

export const paletteOptions: ThemeOptions = {
    palette: {
        general: {
            primary10: '#ffede9',
            primary20: '#ffded6',
            primary30: '#ffcabd',
            primary50: '#ff3200',
            primary60: '#df2c00',
            primary80: '#c12600',
            secondary10: '#f3ebfc',
            secondary20: '#e7daf8',
            secondary30: '#dfccf6',
            secondary50: '#6c19d4',
            secondary60: '#5716aa',
            secondary80: '#400b83',
        },
        grayscale: {
            bWtoDark: '#fffffd',
            bw10: '#f4f5f7',
            bw60: '#a5acbd',
            bw80: '#797e8b',
            bw95: '#101828',
            shade0: '#ffffff',
            shade5: '#fafafb',
            shade10: '#f4f5f7',
            shade20: '#e9ebef',
            shade40: '#dcdee7',
            shade60: '#cdd1da',
            shade80: '#aaaeba',
            shade85: '#8d919a',
            shade90: '#676b74',
            shade95: '#1e2127',
            shade98: '#141414',
            shade100: '#000000',
        },
        infoCustom: {
            green10: '#ebf9f0',
            green20: '#d2f1dd',
            green30: '#beebcd',
            green50: '#04b240',
            green60: '#049e39',
            green80: '#047c5d',
            orange10: '#fff3eb',
            orange20: '#fee7d6',
            orange30: '#fed8bd',
            orange50: '#fb6a01',
            orange60: '#e56101',
            orange80: '#d15801',
            red10: '#fdebeb',
            red20: '#ffd1d1',
            red30: '#ffbdbd',
            red50: '#ff0000',
            red60: '#e40000',
            red80: '#d00000',
            yellow10: '#fef8e5',
            yellow20: '#fdf3d0',
            yellow30: '#fcecb7',
            yellow50: '#f5c62a',
            yellow60: '#ffb608',
        },
    },
};
